import styled from "styled-components";

export const ItemsTable = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  
  th {
    padding: 12px 8px;
    text-align: left;
    color: #64748b;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e2e8f0;
    white-space: nowrap;
    
    &.center {
      text-align: center;
    }
    
    &.right {
      text-align: right;
    }
  }
  
  td {
    padding: 12px 8px;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: middle;
    
    &.center {
      text-align: center;
    }
    
    &.right {
      text-align: right;
    }
  }
  
  tr:hover td {
    background: #f8fafc;
  }
`;

export const ProcNome = styled.div`
  font-weight: 500;
  color: #1e293b;
  line-height: 1.3;
  
  .grupo {
    display: block;
    font-size: 11px;
    color: #3b82f6;
    font-weight: 400;
    margin-top: 2px;
  }
  
  .faces {
    display: block;
    font-size: 11px;
    color: #9b59b6;
    font-weight: 400;
    margin-top: 2px;
  }
  
  .obs {
    display: block;
    font-size: 11px;
    color: #16a085;
    font-weight: 400;
    margin-top: 2px;
  }
`;

export const ElementoBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  color: #0369a1;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
`;

export const Valor = styled.span<{ showValue?: boolean }>`
  font-weight: 600;
  color: ${props => props.showValue ? '#10b981' : '#94a3b8'};
`;

export const RemoveButton = styled.button`
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: none;
  color: #dc2626;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: linear-gradient(135deg, #fecaca 0%, #fca5a5 100%);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #94a3b8;
  
  .icon {
    font-size: 48px;
    margin-bottom: 12px;
  }
  
  p {
    margin: 0;
    font-size: 14px;
    text-align: center;
  }
`;

